import React, { HTMLAttributes } from 'react';
import Box from '../Box/Box';
import { ActionImageIconButton } from '../IconButton';
import { TIconColor } from '../Icon/constants';
import { TIcon } from '../../types/TStyleVariables';

type TActionIcon = Omit<HTMLAttributes<HTMLDivElement>, 'tabIndex'> & {
  className?: string;
  onClick: (event: React.MouseEvent<Element>) => void;
  icon: TIcon;
  color?: TIconColor;
  tabIndex?: string;
  ariaLabel?: string;
};

const ActionIcon = ({ icon, onClick, color, ariaLabel = '', tabIndex = '0', className, ...rest }: TActionIcon) => {
  const [liveMessage, setLiveMessage] = React.useState(ariaLabel);
  const combinedClassName = `action-icon ${className || ''}`.trim();

  const handleClick = (event: React.MouseEvent<Element>) => {
    onClick(event);
    setLiveMessage(ariaLabel);
  };

  return (
    <Box as="div" name="Action-icon" className={combinedClassName} {...rest}>
      <ActionImageIconButton
        name={icon}
        onClick={handleClick}
        color={color}
        tabIndex={tabIndex}
        ariaLabel={ariaLabel}
        type="button"
      />
      <Box name="Sr-only" as="div" aria-live="polite" aria-atomic={true}>
        {liveMessage}
      </Box>
    </Box>
  );
};

export default ActionIcon;
